import { createApp } from 'vue';
import App from './App.vue';
import './components';

createApp(App).mount('#root');
